// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-list-x2/event-list-x2.component.scss
// module id = 274
// module chunks = 0